<template>
	<div>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអំពីការបង់ប្រាក់</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ប្រាក់ដើមត្រូវបង់ *</label>
							<md-input type="number" v-model="loan.principal" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ការប្រាក់ត្រូវបង់ *</label>
							<md-input type="number" v-model="loan.current_interest" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ចំនួនខែបង់ជាដំណាក់កាល *</label>
							<md-input type="number" v-model="loan.total_month_step" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ទឹកប្រាក់បង់ជាដំណាក់កាល *</label>
							<md-input type="number" v-model="loan.total_payment_step" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ចំនួនខែរំលោះគ្មានការប្រាក់ *</label>
							<md-input type="number" v-model="loan.total_month_no_interest" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ទឹកប្រាក់បង់ប្រចាំខែគ្មានការប្រាក់ *</label>
							<md-input type="number" v-model="loan.total_payment_no_interest" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ការប្រាក់ប្រចាំឆ្នាំ *</label>
							<md-input type="number" v-model="loan.interest" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ចំនួនខែរំលោះមានការប្រាក់ *</label>
							<md-input type="number" v-model="loan.total_month_interest" @keyup="clearPayment()"></md-input>
						</md-field>
					</div>
					<!-- <div class="md-layout-item md-size-100 text-right">
						<md-button :class="{'md-raised': true, 'md-primary': loan.valid}" :disabled="!loan.valid" @click="">
							Preview</md-button>
					</div> -->

				</div>

			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 40%;">លេខកូដរំលោះ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span>{{loan_data.hash}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 40%;">អតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{loan_data.client_name}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខឡូតិ៍</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{loan_data.lot}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>រយៈពេលបង់ជាដំណាក់កាល</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold" v-if="String(loan.total_month_step).length > 0">{{loan.total_month_step}} ខែ</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>បង់ប្រចាំខែជាដំណាក់កាល</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold" v-if="String(loan.total_payment_step).length > 0">{{config.moneylify(loan.total_payment_step)}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>រយៈពេលរំលោះគ្មានការប្រាក់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold" v-if="String(loan.total_month_no_interest).length > 0">{{loan.total_month_no_interest}} ខែ</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>បង់ប្រចាំខែគ្មានការប្រាក់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold" v-if="String(loan.total_payment_no_interest).length > 0">{{config.moneylify(loan.total_payment_no_interest)}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>រយៈពេលរំលោះមានការប្រាក់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold" v-if="String(loan.total_month_interest).length > 0">{{loan.total_month_interest}} ខែ</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ការប្រាក់ប្រចាំឆ្នាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{loan.interest}}% (per annual)</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ប្រាក់ដើម</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{config.moneylify(loan.balance)}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ប្រាក់ដើមត្រូវបង់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{config.moneylify(loan.principal)}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ការប្រាក់ត្រូវបង់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{config.moneylify(loan.current_interest)}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ប្រាក់ដើមនៅសល់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{config.moneylify(loan.balance - loan.principal)}}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ទឹកប្រាក់ត្រូវទូទាត់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span class="bold">{{config.moneylify(parseFloat(this.loan.principal) + parseFloat(this.loan.current_interest))}}</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>

			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="calculateLoan()">បង្ហាញតារាងរំលោះ</md-button>
				<md-button class="md-raised md-primary" @click="createLoan()">បង្កើត</md-button>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" v-if="loan.payment.length > 0">
				<h3>តារាងបង់រំលោះថ្មី</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" v-if="loan.payment.length > 0">
				<md-table>
					<md-table-row>
						<md-table-head>ល.រ</md-table-head>
						<md-table-head>ថ្ងៃបង់ប្រាក់</md-table-head>
						<md-table-head>ប្រាក់ដើម</md-table-head>
						<md-table-head>ការប្រាក់</md-table-head>
						<md-table-head>ទឹកប្រាក់ត្រូវបង់</md-table-head>
						<md-table-head>ទឹកប្រាក់នៅសល់</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
					</md-table-row>
					<md-table-row v-for="(payment, index) in loan.payment_before">
						<md-table-cell>{{index}}</md-table-cell>
						<md-table-cell>{{payment[4]}}</md-table-cell>
						<md-table-cell>{{config.moneylify(payment[1])}}</md-table-cell>
						<md-table-cell>{{config.moneylify(payment[2])}}</md-table-cell>
						<md-table-cell><b>{{config.moneylify(parseFloat(payment[1]) + parseFloat(payment[2]))}}</b></md-table-cell>
						<md-table-cell>{{config.moneylify(payment[3])}}</md-table-cell>
						<md-table-cell>បានទូទាត់</md-table-cell>
					</md-table-row>
					<md-table-row v-for="(payment, index) in loan.payment">
						<md-table-cell>{{index + loan.payment_before.length}}</md-table-cell>
						<md-table-cell>{{payment[4]}}</md-table-cell>
						<md-table-cell>{{config.moneylify(payment[1])}}</md-table-cell>
						<md-table-cell>{{config.moneylify(payment[2])}}</md-table-cell>
						<md-table-cell><b>{{config.moneylify(parseFloat(payment[1]) + parseFloat(payment[2]))}}</b></md-table-cell>
						<md-table-cell>{{config.moneylify(payment[3])}}</md-table-cell>
						<md-table-cell>
							<span v-if="index == 0"><b>ហ្នឹងត្រូវទូទាត់</b></span>
							<span v-else>មិនទាន់ទូទាត់</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getLoan();
			this.getPayment();
		},

		data() {
			return {
				loaded: false,
				loadMore: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					clientList: [],
					type: "",
					text: "",
					status: ""
				},
				loan_data: null,
				loan: {
					balance: "",
					principal: "",
					principal_date: "",
					current_interest: "",
					interest: "",
					total_month_interest: "",
					total_month_step: "",
					total_payment_step: "",
					total_month_no_interest: "",
					total_payment_no_interest: "",
					payment_before: [],
					payment: [],
				},
				paymentList: [],
				loadMore: true
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash).then(data => {
					this.loan_data = data.body.data
					this.loan.interest = this.loan_data.interest_rate;
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash).then(data => {
					let paymentList = data.body.data
					for(let i =0; i < paymentList.length; i++) {

						if(paymentList[i].status == 'pnd') {
							paymentList[i].next = 1;
							this.loan.principal = paymentList[i].principal;
							this.loan.balance = paymentList[i].principal + paymentList[i].balance;
							this.loan.current_interest = paymentList[i].interest.toFixed(2);
							this.loan.principal_date = paymentList[i].due_date;
							break;
						} else {
							this.loan.payment_before.push([paymentList[i].hash, paymentList[i].principal, paymentList[i].interest, paymentList[i].balance, this.config.getPaymentDate(paymentList[i].due_date * 1000)]);
						}
					}
					this.paymentList = paymentList
				})
			},
			createLoan() {

				if (String(this.loan.principal).length > 0 &&
				String(this.loan.principal_date).length > 0 &&
				String(this.loan.interest).length > 0 &&
				String(this.loan.total_month_interest).length > 0) {
					console.log(this.loan);
					this.$http.post(this.config.api + "/admin/loan/add_principal", {
						hash: this.$route.params.hash,
						loan: this.loan,
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "រំលោះត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.$router.push("/loans/detail/" + data.body.data.hash);
						}
					})
				} else {
					this.$notification.notify({
							message: "សូមបំពេញព័ត៌មានអោយបានត្រឹមត្រូវ",
							icon: 'error',
							type: 'danger'
					})
				}
			},
			calculateLoan() {
				this.loan.payment = [];
				if (String(this.loan.principal_date).length > 0) {

					let amount = parseFloat(this.loan.balance - this.loan.principal) || 0;

					let total_month_step = parseInt(this.loan.total_month_step) || 0;
					let total_payment_step = parseFloat(this.loan.total_payment_step) || 0;

					let total_month_no_interest = parseInt(this.loan.total_month_no_interest) || 0;
					let total_payment_no_interest = parseFloat(this.loan.total_payment_no_interest) || 0;

					let total_month_interest = parseInt(this.loan.total_month_interest) || 0;
					let interest = parseFloat(this.loan.interest) || 0;

					let start_payment_date = parseInt(this.loan.principal_date) * 1000;

					let payments = [];
					let t = 0;

					// add principal
					payments.push([t, this.loan.principal, this.loan.current_interest, amount, this.config.getPaymentDate(start_payment_date, t)]);
					t++;

					// step payment
					if(parseInt(total_month_step) > 0 && parseFloat(total_payment_step) > 0) {

						for(let i =0; i< total_month_step; i++) {
							amount = amount - total_payment_step;
							payments.push([t, total_payment_step, 0, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					// no interest payment
					if(parseInt(total_month_no_interest) > 0 && parseFloat(total_payment_no_interest) > 0) {

						for(let i =0; i< total_month_no_interest; i++) {
							amount = amount - total_payment_no_interest;
							payments.push([t, total_payment_no_interest, 0, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					// interest payment
					if(parseInt(total_month_interest) > 0 && parseFloat(interest) > 0) {
						let monthly_interest = (interest / 100) / 12;
						let payment = parseFloat(amount * (monthly_interest/(1-Math.pow(1+monthly_interest, -1 * total_month_interest)))).toFixed(3);

						for(let i = 0; i < total_month_interest; i++) {
							let payment_interest = (amount * monthly_interest * 10 / 10).toFixed(3);
							let principal = 0;
							if(total_month_interest == i + 1) {
								principal = amount;
							} else {
								principal = parseFloat(payment - payment_interest).toFixed(3);
							}
							amount = parseFloat(amount - principal).toFixed(3);
							payments.push([t, principal, payment_interest, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					let last_payments = payments.length - 1;
					if(payments[last_payments][3] != 0) {
						payments[last_payments][1] = payments[last_payments][1] + payments[last_payments][3];
						payments[last_payments][3] = 0;
					}

					this.loan.payment = payments;

				} else {
					this.loan.payment = [];
				}
			},
			searchProject() {
				this.$http.post(this.config.api + "/admin/project/search", {
					text: ""
				}).then(data => {
					this.projectList = data.body.data;
					this.loaded = true;
				})
			},
			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {
				this.loan.client_id = "";
				this.loan.client = [];
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},

			clearPayment() {
				this.loan.payment = [];
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.bold {
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/AddPrincipal.vue